const category = 'Multiselect';

export const SegmentMultiSelectEvent = {
    OPENED: {category, event: 'Multilselect opened'},
    CARD_REMOVED: {category, event: 'Card removed from multiselect'},
    LIST_REMOVED: {category, event: 'List removed from multiselect'},
    DELETE_CARDS_CHOSEN: {category, event: 'Delete cards chosen'},
    DELETE_LISTS_CHOSEN: {category, event: 'Delete lists chosen'},
    SELECT_CARDS_CHOSEN: {category, event: 'Select cards chosen'},
    COPY_CARDS_CHOSEN: {category, event: 'Copy cards chosen'},
    CARDS_MARKED_DONE: {category, event: 'Cards marked as done'},
    COLOUR_TAG_OPENED: { category, event: 'Colour tags dropdown menu opened in multiselect' },
    COLOUR_TAG_ADDED: {category, event: 'Colour tag added in multiselect'},
    COLOUR_TAG_REMOVED: {category, event: 'Colour tag removed in multiselect'},
    COLOUR_TAG_CLEAR: { category, event: 'No colour tags in multiselect' },
    COLOUR_TAG_EDIT: { category, event: 'Edit colour tags clicked in multiselect, boards details opened' },
    BACKGROUND_COLOR_OPENED: { category, event: 'Cards colour dropdown menu opened in multiselect' },
    BACKGROUND_COLOR_CHANGED: { category, event: 'Cards colour changed in multiselect' },
    BACKGROUND_COLOR_SHOW_MORE_CLICKED: { category, event: 'Cards colour show more clicked in multiselect' },
    BACKGROUND_LIST_COLOR_OPENED: { category, event: 'Lists colour dropdown menu opened in multiselect' },
    BACKGROUND_LIST_COLOR_CHANGED: { category, event: 'Lists colour changed in multiselect' },
    USER_ASSIGNED: {category, event: 'User assigned in multiselect'},
    USER_UNASSIGNED: {category, event: 'User unassigned in multiselect'},
    PRIORITY_APPLIED: {category, event: 'Priority applied in multiselect'},
    EXISTING_TAG_APPLIED: {category, event: 'Existing tag applied in multiselect'},
    NEW_TAG_APPLIED: {category, event: 'Newly created tag applied in multiselect'},
    SHOW_GANT: {category, event: 'Show on gantt in multiselect'},
    OPEN_MOVE_TO_DROPDOWN: {category, event: 'Open move to dropdown in multiselect'},
    MOVE_TO_CARD_MOVED: {category, event: 'Move to - cards moved'},
    MOVE_TO_LIST_MOVED: {category, event: 'Move to - lists moved'},
    ARCHIVE_CARDS_CLICKED: {category, event: 'Archive cards clicked'},
    ARCHIVE_LISTS_CLICKED: {category, event: 'Archive lists clicked'},
    UNARCHIVE_CARDS_CLICKED: {category, event: 'Unarchive cards clicked'},
    UNARCHIVE_LISTS_CLICKED: {category, event: 'Unarchive lists clicked'},
    START_DATE_SELETCED: {category, event: 'Start date selected in multiselect'},
    DUE_DATE_SELETCED: {category, event: 'Due date selected in multiselect'},
    START_DATE_TIME_SELETCED: {category, event: 'Start date time selected in multiselect'},
    DUE_DATE_TIME_SELETCED: {category, event: 'Due date time selected in multiselect'},
    CARD_LIMIT: {category, event: 'Cards limit set in list multiselect'},
    SORTING_DENIED: { category, event: 'Cards sorting in list (no success)' },
    SORTING_ON: { category, event: 'Cards sorting in list - on' },
    SORTING_OFF: { category, event: 'Cards sorting in list - off' },
    DESCENDING_SORTING_ON: { category, event: 'Descending cards sorting set in list details' },
    ASCENDING_SORTING_ON: { category, event: 'Ascending cards sorting set in list details' },
    PRIORITY_SORTING_ON: { category, event: 'Cards sorting by priority set in list details' },
    START_DATE_SORTING_ON: { category, event: 'Cards sorting by start date set in list details' },
    DUE_DATE_SORTING_ON: { category, event: 'Cards sorting by due date set in list details' },
    PROGRESS_SORTING_ON: { category, event: 'Cards sorting by progress set in list details' },
    ASSIGNED_USER_SORTING_ON: { category, event: 'Cards sorting by assigned users set in list details' },
    ESTIMATE_SORTING_ON: { category, event: 'Cards sorting by estimate set in list details' },
    TITLE_SORTING_ON: { category, event: 'Cards sorting by title set in list details' },
    PREFIX_SORTING_ON: { category, event: 'Cards sorting by prefix set in list details' },
    AGE_SORTING_ON: { category, event: 'Cards sorting by card`s age set in list details' },
    COLOR_LABEL_SORTING_ON: { category, event: 'Cards sorting by card`s color labels set in list details' },
    CARD_ACTIVITY_SORTING_ON: { category, event: 'Cards sorting by card`s last activity set in list details' },
    CARD_AGING_CLICKED: {category, event: 'Card aging clicked'},
    CARD_AGING_INDICATOR_CLICKED: {category, event: 'Card aging indicator clicked'},
    CARD_AGING_OPACITY_CLICKED: {category, event: 'Card aging opacity clicked'},
    CARD_AGING_WITHOUT_ACTIVITY_CLICKED: {category, event: 'Card aging without activity clicked'},
    CARD_AGING_IN_LIST_CLICKED: {category, event: 'Card aging in list clicked'},

    START_DATE_CLICKED_CLEAR: { category, event: 'Start date clear clicked in multiselect' },
    DUE_DATE_CLICKED_CLEAR: { category, event: 'Due date clear clicked in multiselect' },
    START_DATE_OPENED: { category, event: 'Start date dropdown opened in multiselect' },
    DUE_DATE_OPENED: { category, event: 'Due date dropdown opened in multiselect' },
    START_TIME_CLICKED: { category, event: 'Start date time dropdown opened in multiselect' },
    DUE_TIME_CLICKED: { category, event: 'Due date time dropdown opened in multiselect' },
    START_TIME_CHOOSE_UNEVEN: { category, event: 'Uneven start date time applied in multiselect' },
    DUE_TIME_CHOOSE_UNEVEN: { category, event: 'Uneven due date time applied in multiselect' },

    ESTIMATE_ADDED: {category, event: 'Estimate added in multiselect'},
    ESTIMATE_ERROR: {category, event: 'estimate invalid value in multiselect'},

    COPY_CHECKLIST_OPENED: { category, event: 'Copy checklists dropdown menu opened in multiselect' },
}

export enum SegmentMultiSelectOptions {
    STATUS = 'status',
    TARGET = 'target',
    TYPE = 'type',
}

export enum SegmentMultiSelectOptionStatusValue {
    ON = 'on',
    OFF = 'off',
}

export enum SegmentMultiSelectColorTargetValue {
    BOARD_COLORS = 'Board colors',
    ALL_COLORS = 'All colors'
}

export enum SegmentMultiSelectTypeValue {
    LIST = 'list',
}
